import * as mac from "@/data/api/mac"
import {getWidgetMap, WidgetDefinition} from "@/components/widgets/WidgetFather"
import {filterPrefix} from "@/utils"
import {widgetByName} from "@/data/sources/widgetResolver"

interface WidgetInstances {
  panelId: number,
  instances: WidgetInstance[]
}

interface WidgetInstance {
  id?: number,
  panelId: number,
  widgetName: string,
  configuration: WidgetDefinition
}

export async function widgetInstancesList(
  panelId: string): Promise<WidgetDefinition[]> {
  try {
    const r = await mac.api.get("widgetInstances/list", {params: {panelId}})
    return widgetInstancesListTransform(r.data)
  } catch (err) {
    console.error("widgetInstancesList failed", err)
    return []
  }
}

export function widgetInstancesListTransform(
  data: WidgetInstances): WidgetDefinition[] {
  const filteredData: WidgetDefinition[] = []
  const wl = getWidgetMap()
  for (const item of data.instances as WidgetInstance[]) {
    const wc = item.configuration
    const wInfo = wl.get(item.widgetName) || {title: ""}
    wc.widget = widgetByName(item.widgetName)
    wc._description = wInfo.title
    wc.i = item.id + '_' + item.widgetName
    wc.wc = {
      id: item.id,
      panelId: item.panelId,
      widgetName: item.widgetName,
    }
    filteredData.push(wc)
  }
  return filteredData
}

export async function widgetInstancesUpdate(
  data: WidgetDefinition[],
  panelId: number): Promise<WidgetDefinition[]> {
  try {
    const r = await mac.api.post("widgetInstances/update", widgetInstancesUpdateTransform(data, panelId))
    if (!r || r.data === undefined) {
      throw Error("Failed to save widgets")
    }
    return widgetInstancesListTransform(r.data)
  } catch (err) {
    console.error("widgetInstancesUpdate failed:", err)
    return [] as WidgetDefinition[]
  }
}

function widgetInstancesUpdateTransform(
  data: WidgetDefinition[],
  panelId: number): WidgetInstances {
  const filteredData: WidgetInstance[] = []
  for (const item of data) {
    if (item.wc !== undefined) {
      const wi: WidgetInstance = {
        id: item.wc.id,
        panelId: item.wc.panelId,
        widgetName: item.wc.widgetName,
        configuration: {
          x: item.x,
          y: item.y,
          w: item.w,
          h: item.h,
          title: item.title,
          theme: item.theme,
          cType: item.cType,
          params: item.params,
          fusionChartParams: item.fusionChartParams,
        } as WidgetDefinition,
      }
      filteredData.push(filterPrefix(wi))
    } else {
      throw(Error('widget is missing WidgetInstance data ¯\_(ツ)_/¯'))
    }
  }
  return {instances: filteredData, panelId} as WidgetInstances
}
